import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendModel } from '../../../../features/site/siteSlice'

import { serviceMap } from '../../../utils/common'
import GAService from '../../Admin/ServiceTypes/GoogleAnalytics'

import ServiceCardBase from '../ServiceCardBase'

function GoogleAnalytics({ onSave, onCancel}){
    const dispatch = useDispatch()
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)
    const site = model?.sites[model.siteActiveIdx]

    const { siteForm } = model

    const editSite = async() => {
        await dispatch(appendModel({
            siteForm: {
                ...siteForm,
                attr: {
                    ...siteForm.attr,
                    accounts: {
                        ...(siteForm?.attr?.accounts ?? {}),
                        ga: undefined
                    }
                }
            }
        }))
    }

    return <ServiceCardBase 
        title="Google Analytics" 
        header="Google Analytics" 
        description=" "
        image={serviceMap.ga.img}>
            <GAService design="onboarding" ga4Only={true} />
            <div class="d-flex flex-row-reverse justify-content-between">
                <div>
                    {siteForm?.attr?.accounts?.ga && (localStorage.getItem("gaSelection") !== null || localStorage.getItem("ga4Selection") !== null) && <button className="mr-3 btn btn-lg btn-outline-primary" onClick={() => editSite()}>
                        Edit
                    </button>}
                    {/* {siteForm?.attr?.accounts?.ga && oauthTokens?.ga && <button className="btn btn-lg btn-success" onClick={async() => {
                        await onSave()
                    }}>Save</button>} */}
                </div>
            </div>
    </ServiceCardBase>
}

export default GoogleAnalytics